<app-header [showBack]="true"></app-header>
<app-set-meta title="広告掲載に関する規約（掲載企業向け）｜Forbes CAREER"></app-set-meta>

<!-- <app-tab-menu></app-tab-menu> -->
<div class="term-body">
  <h1>広告掲載に関する規約</h1>
  <p>
    この広告掲載に関する規約（以下、「本規約」といいます）は、リンクタイズ株式会社（以下、「当社」といいます）が運営するForbes
    JAPAN
    CAREER（以下、「本サイト」といいます）において、自己の求人等の広告を掲載すべく本サービス（第1条において定義します）を利用する企業等（以下、「掲載企業等」といいます）との関係を規律します。
  </p>
  <h4>第1条（適用の範囲）</h4>
  <p>
    本規約は、本サイト上で提供されるサービス（以下、「本サービス」といいます）に関し、第3条第2項に従って利用申込を行った掲載企業等に対して、当該利用申込の時点から、適用されます。掲載企業等は、当該利用申込をもって、本規約及び当社が定めるプライバシーポリシー（以下、併せて「本規約等」といいます）に同意したものとみなします。
  </p>
  <h4>第2条（必要環境）</h4>
  <p>
    本サービスの利用には、インターネットへの接続が必要です。掲載企業等は、自らの費用と責任において、本サービスを利用するために必要なコンピューター端末、通信機器その他の機器の調達、セットアップ及び接続等を行い、また、技術水準等に適合するよう維持するものとします。電気通信設備に関する通信費、保守費等は掲載企業等が負担するものとします。
  </p>
  <h4>第3条（本サービスの利用）</h4>
  <ol>
    <li>
      本サービスは、本規約等のほか、適用される法令等を遵守している掲載企業等に限り、利用することができるものとします。未成年の方は、次項に従って利用申込を行った時点において、保護者（法定代理人）から本規約等を遵守の上で本サービスを利用する許可を得ていることを表明し、保証したものとみなします。
    </li>
    <li>
      本サービスの利用を希望する掲載企業等は、本規約等の内容に同意した上で、当社所定の方法により、利用申込の手続きを行い、自身のアカウント（以下、「本アカウント」といいます）を作成するものとします。なお、利用申込に際しては、以下の各号を遵守するものとします。
      <ol>
        <li>
          登録するパスワードその他の掲載企業等にかかる情報は、自己の責任において大切に保管し、他人に知られることがないよう機密として厳重に保持するものとします。
        </li>
        <li>
          登録する電話番号、住所や電子メールアドレスその他の連絡先情報に対して、当社からのお知らせや広告等の連絡に供されること（登録した端末にプッシュ通知が送信される可能性があることを含みます）を了承し、それら連絡先情報について、当社からの連絡を必ず受け取ることができるものを選択するとともに、その受取可能な状態を維持するものとします。
        </li>
        <li>
          権限のない者により本アカウントが利用された可能性があると認識した場合、ただちに当社に通知するものとします。
        </li>
      </ol>
    </li>
    <li>
      当社は、掲載企業等が以下の各号に該当すると判断した場合、事前の通知・催告等を経ることなく、当該掲載企業等による本アカウントの恒久的又は一時的な利用制限や削除、当該掲載企業等による本サービスの恒久的又は一時的な利用停止、当該掲載企業等による本サイトへのアクセスの恒久的又は一時的な停止等の措置（以下、併せて「利用制限等措置」といいます）を講じることができるものとします。なお、当社は、利用制限等措置を講じる義務を負うものではありません。
      <ol>
        <li>本規約等に違反した場合。</li>
        <li>（掲載企業等が個人の場合）死亡した場合又は後見開始、補佐開始若しくは補助開始の審判を受けた場合。</li>
        <li>
          （掲載企業等が個人以外の場合）自己振出若しくは引受の手形若しくは小切手を不渡とした場合、支払不能若しくは支払停止の状態となった場合又は破産手続、民事再生手続、会社更生手続、特別清算手続その他の法的倒産手続が開始された場合。
        </li>
        <li>過去に利用制限等措置を講じられたことがある場合（第12条第③号による当社許可の有無を問いません）。</li>
        <li>
          本アカウントが権限のない者により利用された形跡がある場合（本条第2項第③号による会員からの通知の有無を問いません）。
        </li>
        <li>
          暴力団、暴力団員、暴力団準構成員、総会屋、社会運動等標榜ゴロ、特殊知能暴力集団その他これに準じる反社会的勢力（以下、併せて「反社会的勢力等」といいます）であると判明した場合、又は資金提供その他の行為を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与する等反社会的勢力等との何らかの交流若しくは関与をしている場合。
        </li>
        <li>上記の他、利用制限等措置が適切であると当社が判断した場合。</li>
      </ol>
    </li>
  </ol>
  <h4>第4条（本サービスの範囲）</h4>
  <ol>
    <li>
      掲載企業等は、当社指定の方法で広告掲載の手続きを行うことにより、最初の掲載が行われた日の12か月後応当日までの期間中（以下、「本掲載期間」といいます）、本サイト上で自身のコンテンツ（記事広告・求人情報等）を掲載することができるものとします。
    </li>
    <li>
      前項にかかわらず、掲載企業等が、自身の求人情報等について当社指定の方法で掲載中止の手続き（以下、「掲載中止手続き」といいます）を行った場合には、その完了時から当社指定の方法で掲載再開の手続き（以下、「掲載再開手続き」といいます）を行うまでの間、当該求人情報の掲載は中止されます。この場合、当該掲載中止手続き完了の翌月から当該掲載再開手続き完了の前月末までの期間（以下、「掲載中止期間」といいます）は、本掲載期間の進行が停止するものとし、掲載再開手続きが行われた場合には、掲載中止期間の月数分、本掲載期間が延長するものとします。なお、掲載中止手続きを行ったことは第13条に基づく料金の支払いに影響を及ぼすことはありません。
    </li>
    <li>
      本掲載期間（前項による延長が生じた場合には当該延長による期間とします。以下、特段の言及がない限り同様とします）が満了する日（以下、「満了日」といいます）までに、掲載企業等が、自身の求人情報について当社指定の方法により掲載終了の手続き（以下、「掲載終了手続き」といいます）を完了した場合には、その時点において本サービスは全て終了します。なお、掲載終了手続きを行ったことは第13条に基づく料金の支払いに影響を及ぼすことはありません。また、掲載中止期間中に掲載再開手続きが行われることなく、当該掲載中止手続きがなかったと仮定した場合の満了日が到来した場合には、当該掲載企業等は、本項に従って掲載終了手続きを完了したものとみなします。
    </li>
    <li>前各項による、掲載中止手続き、掲載再開手続き及び掲載終了手続きは、掲載企業等自身が行うものとします。</li>
    <li>
      掲載企業等は、第1項による求人情報の掲載のほか、本掲載期間中に一度、当社と別途協議するところに従って、本サイト上に当社が作成する当該掲載企業等にかかる記事広告（以下、「記事広告」といい、求人情報と併せて「求人情報等」といいます）を掲載する権利を有するものとします。
    </li>
    <li>
      本サービスは、当社が、掲載企業等に対して、特定若しくは不特定の候補者を紹介又は推薦する性質のものではなく、また、候補者による応募や入社等を保証するものではありません。当社が保有するデータベースの使用を掲載企業等に許諾した場合であっても、候補者の探索、検索、条件照合、選定及び採否の決定並びに候補者に対する連絡、通知及び交渉等は、全て掲載企業等自身の判断と責任において行うものとします。当社は、候補者と掲載企業との間で行われる連絡等に一切関与せず、また、何ら責任を負わないものとします。
    </li>
    <li>
      当社は、ユーザビリティの向上と効果の可視化を目的として、コンテンツ上にWEB接客ツールを用いたアンケートや企業ページ等の導線の設置を、掲載企業等への事前の通知なく行うことができるものとします。当社は、その結果の共有について義務を負うものではなく、また内容を保証するものではありません。
    </li>
    <li>
      掲載企業等は、本掲載期間中における当社SNSアカウント等を通じた記事の発信につき、当社にその制作を一任することに合意します。
      <br />
      当社は、掲載企業等から事前に提供された禁忌ワードを避け制作するものとします。
    </li>
  </ol>
  <h4>第5条（業務代行）</h4>
  <p>
    当社は、本サービスの提供にあたり、事前の通知・催告等を経ることなく、本サービスにかかる各種手続きの代行、掲載企業等に対する広告掲載料の請求その他の業務を第三者に委託することができるものとします。
  </p>
  <h4>第6条（本規約の変更）</h4>
  <ol>
    <li>
      <p>
        当社は、以下の場合に、本規約を変更することができるものとします。
        <br />
        本規約の変更が、掲載企業等の一般の利益に適合するとき。
        <br />
        本規約の変更が、本申込書の目的に反せず、かつ、変更の必要性、変更後の内容の相当性、変更の内容その他の変更に係る事情に照らして合理的なものであるとき。
      </p>
    </li>
    <li>
      <p>
        当社は、変更後の本規約の効力発生日の１か月前までに、本サイト又は掲載企業等に別途通知するウェブサイト上で公開します。変更後の本規約の効力発生日以降も掲載企業等が本サービスの利用を継続する場合には、変更後の本規約に同意したものとみなします。
      </p>
    </li>
  </ol>
  <h4>第7条（法令遵守）</h4>
  <p>
    当社は、掲載企業等に本サービスを提供するにあたり厚生労働省職業安定局の令和２年４月付「募集情報等提供事業の業務運営要領」を含む各種法令を遵守するものとする。
  </p>
  <h4>第8条（本サービスの変更・停止・終了）</h4>
  <p>
    本サービスは、事前の通知等を経ることなく、その全部若しくは一部の提供が終了、停止又は変更されることがあり、また、本サービスの利用に新たな制約が課されることがあります。
  </p>
  <h4>第9条（登録内容の保証）</h4>
  <ol>
    <li>掲載企業等は、当社に対し、本サービスに関わり登録した情報の内容が事実に反しないことを保証するものとします。</li>
    <li>
      掲載企業等は、当社に対し、本サービスに関わり登録した情報に第三者の情報が含まれている場合には、当該登録することに関して当該第三者の承諾を得ていることのほか、当該第三者等の著作権、商標権、肖像権その他の権利を侵害していないことを保証するものとします。
    </li>
    <li>
      掲載企業等は、当社に対し、本サービスに関わり写真、ロゴマーク、文書等の情報を当社に提供する場合には、それら情報の使用等に関して必要な知的財産権等（第11条において定義します）の権利を自ら保有し又はその使用等を正当な権利者より許諾されていることを保証します。
    </li>
    <li>
      当社は、前各項の事実確認のため、掲載企業等に対して必要な報告を求め、また、資料の提出を求めることができ、この場合、掲載企業等は、速やかに当社の求めに応じるものとします。但し、当社は、かかる報告要求等の義務を負うものではありません。
    </li>
    <li>
      第1項又は第2項による保証内容が事実に反したため、本サービスのユーザー会員その他の第三者との間で紛争が生じた場合、掲載企業等は、自己の費用と責任をもって当該紛争を解決するものとし、当社は、当該紛争について、何ら責任を負わないものとします。
    </li>
  </ol>
  <h4>第10条（掲載企業等の義務）</h4>
  <ol>
    <li>
      掲載企業等は、当社の定める基準に従って、自己の責任と判断において本サービス上で企業情報や求人情報等の情報を設定するものとします。
    </li>
    <li>
      当社は、掲載企業等が設定した情報が当社基準に反する又は事実に反すると判断した場合には、当該掲載企業等に対して当該情報の削除若しくは訂正を求め又は当該掲載企業等にかかる情報の公開範囲を変更し若しくは非公開にすることができます。但し、当社は、かかる削除を求める等の義務を負うものではありません。
    </li>
    <li>
      掲載企業等は、その名称、住所、代表者、請求書の送付先等に変更があったときは、速やかに当社に修正を届け出るものとします。
    </li>
  </ol>
  <h4>第11条（著作権等について）</h4>
  <ol>
    <li>
      本サービスに関わる著作権、商標権その他の知的財産権及びその他の権利等の財産権（本サイト上のコンテンツ（以下、「本コンテンツ」といいます）にかかるものを含め、以下、併せて「知的財産権等」といいます）はすべて、当社又は正当な権利を有する第三者に帰属します。
    </li>
    <li>
      掲載企業等は、当社が求人情報等の全部又は一部を本サイトに掲載するにあたって自由に複製・改変・削除等を行うことを予め承諾するものとし、著作者人格権を有する場合でも、行使しないものとします。掲載企業等は、前項による複製等に対して利害関係（知的財産権等を含みます）を有する第三者から、予め本サービスでの利用及び前項による複製等にかかる許諾を得るとともに、必要な権利処理の一切を行うものとし、また、当該第三者からクレーム、請求等がなされた場合には、掲載企業等の費用と責任において対応にあたり、当社は何ら責任を負わないものとします。
    </li>
  </ol>
  <h4>第12条（禁止事項）</h4>
  <p>掲載企業等は、本サービスの利用にあたり、以下の行為を自ら行わず、また、第三者をして行わせないものとします。</p>
  <ol>
    <li>当社の書面による承諾なくして、他人名義のアカウントを作成すること。</li>
    <li>本アカウントを複数作成すること。</li>
    <li>利用制限等措置を講じられた後、当社の書面による承諾なくして、新たな本アカウントを作成すること。</li>
    <li>
      本アカウントにかかるID及びパスワードの他人との共有、他人に対する本アカウントの譲渡、他人に対する本アカウントへのアクセスの許可等の本アカウントを利用させる行為その他の本アカウントのセキュリティを脅かす恐れのある行為。
    </li>
    <li>
      本コンテンツ（記事広告及び当社が前条第2項により複製等を行った求人情報を含みます）を著作権法で認められた私的使用の範囲を超えて、複製、出版、公表、譲渡、公衆送信、貸与、翻訳、使用許諾、転載、改変その他の態様で利用すること。
    </li>
    <li>
      自動化された手段(情報収集ボット、ロボット、スパイダー、スクレーパーなど)を使用して、本アカウント作成し又は本アカウントにアクセスすること。
    </li>
    <li>当社又は正当な権利を有する権利者の知的所有権等を侵害する行為若しくはそれらを侵害する恐れのある行為。</li>
    <li>
      本サービスの提供にかかわり使用される当社又は第三者の通信設備、コンピューターその他の機器若しくはソフトウェアに不正にアクセスすること、又は、それらの利用若しくは運用に支障を与える行為又は与える恐れのある行為。
    </li>
    <li>
      当社の書面による承諾なくして、当社の商号、商標及びロゴ並びに当社ウェブサイト（本サイトに限りません）上の情報（本サービスの名称や本サービスにかかる資料を含みます）、レイアウト及びデザイン等のコンテンツ（本コンテンツに限りません）の全部若しくは一部を使用、表示、ミラー、フレームすること又はフレーム技術を使用してエンクローズすること。
    </li>
    <li>不正な商用メッセージ(迷惑メールなど)を投稿すること。</li>
    <li>ピラミッド商法など、非合法なマルチ商法などを実施すること。</li>
    <li>特定の宗教団体や宗教活動へ勧誘すること。</li>
    <li>ウイルス又はその他の悪質なコードをアップロードすること。</li>
    <li>他の会員のログイン情報を求めること又は他人のアカウントにアクセスすること。</li>
    <li>当社のソースコードについて改変、派生物の作成、デコンパイルその他の操作をすること。</li>
    <li>
      法令に違反する行為、本規約等の違反を助長又は推奨する行為、本サービスの運営を妨害する行為、当社の信用を毀損し若しくは当社の財産を侵害する行為その他の当社に不利益を与える行為。
    </li>
    <li>上記各号のほか、当社が本サービスの利用目的から鑑みて不適切と判断する行為。</li>
  </ol>
  <h4>第13条（支払い）</h4>
  <ol>
    <li>
      本サービス提供の料金は、本掲載期間ごとの金額として当社が定める通りとし、掲載企業等は、当社所定の時期（掲載中止期間中及び掲載終了手続きを完了した後の本掲載期間中の時期を含みます）に所定金額を支払うものとします。なお、支払い方法は以下のいずれかの方法によるものとします。
      <ol>
        <li>請求書発行による金融機関振込での月額払い</li>
        <li>請求書発行による金融機関振込での年間一括払い</li>
      </ol>
    </li>
    <li>
      掲載企業等は、第3条第2項による利用申込が完了した場合には、理由の如何を問わず本サービスの提供を受けられない場合（第3条第3項に基づき利用制限等措置が講じられた場合、第4条に基づく掲載中止手続き又は掲載終了手続きが行われた場合及び第8条に基づき本サービスの提供が終了・停止した場合を含みます）においても、当社に対して、当該本掲載期間に対応した料金の全額を前項に従って支払うことを要するものとし、当社は受領した料金を一切返還いたしません。
    </li>
    <li>
      当社が第1項の料金を変更した場合、当該変更は、その効力が生じた後に利用申込を行った掲載企業等及び第4条第3項に基づき新たな本掲載期間が開始することとなった掲載企業等に対して適用されるものとします。
    </li>
  </ol>
  <h4>第14条（キャンセル）</h4>
  <ol>
    <li>
      求人情報等に関する取材後に掲載企業等が本サービスをキャンセルした場合には、当該原稿が公開されなくとも、キャンセル料が発生します。また、掲載企業等の都合により取材や撮影の日程が変更された場合には、日程再調整料が発生します。
    </li>
    <li>
      キャンセル料及び日程再調整料は、以下の通りとします。なお、すべて税別の価格とします。
      <br />
      《キャンセル料》
      <br />
      取材のみ実施：10万円
      <br />
      撮影のみ実施：10万円
      <br />
      取材・撮影ともに実施し、記事は未完成：20万円
      <br />
      取材・撮影ともに実施し、記事が完成：40万円
      <br />
      《日程再調整料》
      <br />
      撮影・取材予定日前日〜当日：10万円
      <br />
      撮影・取材予定日2日前：9万円
      <br />
      撮影・取材予定日3日前：8万円
      <br />
      撮影・取材予定日4-5日前：6万円
      <br />
      ※上記は地震、津波等の天災、火災、ストライキ、洪水、疫病、暴動又は戦争行為、
      その他当事者の責めに帰することのできない事由によるキャンセル・延期は除くものとします。
      <br />
      ※新型コロナウイルス感染による取材・撮影の中止または延期において、取消料免除の対象となるには、掲載企業の取材対象者者の感染を示す検査結果を当社に報告することが必要です。
      新型コロナウイルス感染者の濃厚接触者と認定された場合もしくは発熱等の症状で取材・撮影を中止または延期を申し出た場合、掲載企業が中止または延期を申し出た日を1日目と起算して5日目にあたる日までに、当該取材対象者の新型コロナウイルスの感染を示す検査結果を当社に報告することによって、取消料免除の対象となります。
      濃厚接触者認定や発熱がある場合には感染拡大防止の観点から日程の再調整を行うこととする。その後、本人の陽性が確認できなかった場合においては、掲載企業と当社にて協議を行い、上記に定めた日程再調整料の範囲内で掲載企業の負担額を決定する。
    </li>
  </ol>
  <h4>第15条（秘密保持義務）</h4>
  <ol>
    <li>
      掲載企業等は、本サービスに関連して知り得た当社の営業上、技術上の秘密に属する情報（以下、併せて「秘密情報」という）を、当社の事前の書面による承諾なくして、本サービスの利用以外の目的で使用してはならず、また、第三者に開示・漏洩等しないものとします。但し、次のいずれかに該当する情報は、秘密情報から除くものとします。
      <ol>
        <li>
          開示を受けた時点で既に掲載企業等において保有していた若しくは公知であったもの又は掲載企業等の責によらずして開示を受けた時点以降に公知となったもの
        </li>
        <li>掲載企業等が第三者から秘密保持義務を負うことなく正当に入手したもの</li>
      </ol>
    </li>
    <li>本条の規定は、本掲載期間満了後も存続するものとします。</li>
  </ol>
  <h4>第16条（免責）</h4>
  <ol>
    <li>当社は、掲載企業等に対し、本サイトの一切の動作保証を行わず、いかなる責任も負いません。</li>
    <li>本サービスにおいて提供される情報の完全性等に当社は一切の責任を負いません。</li>
    <li>
      当社は、掲載企業等に対し、本サービス及び本コンテンツが第三者の知的財産権等を侵害していないことを保証するものではありません。
    </li>
    <li>
      当社は、天災地変その他不可抗力（回線の輻輳、回線の障害、サーバーダウン、郵便事故等を含みますが、これらに限られません）にかかわり掲載企業等に生じた損失につき、何らの責任も負わないものとします。
    </li>
  </ol>
  <h4>第17条（準拠法）</h4>
  <p>本規約は、日本法に準拠し、日本法に基づき解釈されます。</p>
  <h4>第18条（専属的合意管轄裁判所）</h4>
  <p>本規約に関する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>

  <div class="credit">
    以上
    <br />
    2018年3月8日 制定
    <br />
    2022年4月7日 改定
  </div>
</div>
<app-footer></app-footer>

<!-- /.wrapper -->
